import * as Permissions from '../actionTypes/Permissions/Permissions'
import Api from '../Api'
import { Config } from '../Config'
import { CommonConstants } from '../Constants'
import AuthenticationService from '../components/Security/AuthenticationService'
import SecurityService from '../components/Security/SecurityService'
const _ = require('underscore')

function getPermissionSuccess (permissions) {
  return {
    type: Permissions.GET_USER_PERMISSIONS,
    userPermissions: permissions
  }
}

export const getPermission = (callBack) => {
  const authService = new AuthenticationService(Config.authBaseUrl)
  let permissions = authService.getPermission()

  return (dispatch, getState) => {
    if (permissions.length === 0) {
      apiGetPermissions(permissions, authService, dispatch)
    } else {
      dispatch(getPermissionSuccess(permissions))
      apiGetPermissions(permissions, authService, dispatch)
    }
  }
}

export const checkAccess = (permission) => {
  var securityService = new SecurityService()
  return securityService.hasAccess(permission)
}

function apiGetPermissions (permissions, authService, dispatch) {
  const api = new Api()
  if (!authService.isAdmin()) {
    let url = Config.apiBaseUrl + CommonConstants.apiUrls.getPermissions
    if (authService.getUUID()) {
      url += '?uuid=' + authService.getUUID()
    }
    api.getData(url, data => {
      let changedPermissions = _.pluck(data.data[0], 'Permission_Name')
      if (changedPermissions !== permissions) {
        authService.setPermission(changedPermissions)
        dispatch(getPermissionSuccess(permissions))
      // callBack(changedPermissions)
      }
    })
  } else {
    dispatch(getPermissionSuccess([]))
  }
}



// WEBPACK FOOTER //
// ./src/actions/permissions.js